module.exports = __webpack_public_path__ + "static/media/release.b18ca331.png";